import { InputGroup } from "@components/_Revamp/InputGroup";
import { css, cx } from "@linaria/core";
import { styled } from "@linaria/react";
import OthersSpecify from "@pages/EverGreen/Components/Textarea";
import { trackOnFormStartOrSuccess, trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { updatePEPdata } from "@redux/slices/EVER_GREEN/step3Slice";
import { SCREEN_SIZE } from "@static/screen-size";
import { relationship } from "@static/sources";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";

const themeCustom = JSON.parse(JSON.stringify(EverGreenStyle));

function PEPForm({show}:{show:boolean}) {
  const dispatch = useAvivaDispatch();
  const isPEP = useAvivaSelector((s) => s.everGreenStep3.PEP.isPEP);
  const formData = useAvivaSelector(
    (state) => state.everGreenStep3.PEP.PEPData
  );
  const relationships = useAvivaSelector(
    (state) => state.everGreenStep3.PEPList
  );
  const [data, setData] = useState<any>(formData);
  const debouncer = debounce((e) => {
    trackOnFormStartOrSuccess("DS_pep_form")

    dispatch(updatePEPdata({ ...formData, [e.target.name]: e.target.value }));
  }, 100);
  const changeHandler = (e: any) => {
    trackOnFormStartOrSuccess("DS_pep_form")

    if (e.target.value > 100) return;
    debouncer(e);
    setData((prev: any) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  // useEffect(()=>{
  //   if(show){
  //     trackOnLoad()
  //   }
  // },[show])

  return (
    <>
      <Conatiner
        show={isPEP === "YES"}
        className={cx("", isPEP === "YES" && animation)}
      >
        <p style={{ fontSize: EverGreenStyle.fontSize.xs + "px" }}>
          By selecting &lsquo;Yes&rsquo; you will be assigned a Financial Adviser
          Representative who will assist you with the submission of the required
          forms and supporting documents.
        </p>
        <Grid>
          <InputGroup
            id="pep-name"
            name="name"
            label="Name of PEP"
            inputProps={{
              textAlign: "left",
              value: data?.name,
            }}
            inputType="input"
            theme={themeCustom}
            onChange={changeHandler}
          />
          <InputGroup
            label="Relationship to Assured"
            id="pep-relation"
            name="relationship"
            inputType="dropdown"
            placeholder="Select"
            theme={EverGreenStyle}
            dropdownProps={{
              value: data?.relationship,
              source: relationships,
            }}
            onChange={changeHandler}
            onBlurShowError={true}
          />
        </Grid>
      </Conatiner>
      <OthersContentContainer
        show={
          isPEP === "YES" &&
          (data?.relationship?.toLowerCase() === "others" ||
            data?.relationship?.toLowerCase() === "10")
        }
      >
        <div
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: EverGreenStyle.colors.grey[500],
          }}
        >
          Provide more details below
        </div>
        <OthersSpecify
          maxLength={100}
          style={{
            marginTop: "16px",
            color: EverGreenStyle.colors.primary,
            fontSize: "14px",
            fontWeight: 600,
          }}
          name="othersContent"
          charLimitlabel="100"
          placeholder=""
          value={data?.othersContent}
          onChange={changeHandler}
        />
      </OthersContentContainer>
    </>
  );
}

export default PEPForm;

const OthersContentContainer = styled.div<{ show: boolean }>`
  height: ${(props) => (props.show ? "230px" : "0px")};
  transition: all linear 0.3s 0.1s;
  overflow: hidden;
  margin-top: 10px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    margin-top: unset;
  }
`;

const Conatiner = styled.div<{ show: boolean }>`
  height: ${(props) => (props.show ? "250px" : "0px")};
  transition: height 0.3s linear 0.1s;
  overflow: hidden;
  & > p:first-child {
    margin-top: 20px;
  }
  div {
    p {
      font-size: 14px;
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    height: ${(props) => (props.show ? "150px" : "0px")};
    & > p:first-child {
      margin-top: unset;
    }
  }
`;

const animation = css`
  animation: overflowing forwards 0.3s;
  @keyframes overflowing {
    0% {
      overflow: hidden;
    }
    99% {
      overflow: hidden;
    }
    100% {
      overflow: unset;
    }
  }
`;

const Grid = styled.div`
  @media screen and (max-width: calc(${SCREEN_SIZE.mobilesUp}px - 1px)) {
    display: grid;
    margin-top: 24px;
    grid-template-rows: repeat(2, 1fr);
    row-gap: 24px;
    margin-bottom: 50px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    display: grid;
    margin-top: 24px;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 24px;
    row-gap: 24px;
  }
`;
